import { defineComponent as _defineComponent } from 'vue'
import Http from '../../core/http/http.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ThrowXhrError',
  setup(__props) {

function requestError() {
    Http.get('demo/throw').catch(() => {
    });
}


return { __sfc: true,requestError }
}

})